import { setupI18n } from "@lingui/core";
import { messages as koMessages } from "../locale/ko/messages.po";
import { messages as enMessages } from "../locale/en/messages.po";
import { getLocalePreference } from "./locale-preference";
import type { SupportedLocale } from "./locales";

// 카탈로그 규모가 작아 두 로케일을 정적으로 함께 번들링한다 — activate 가
// 동기적으로 끝나 첫 페인트에서 언어가 튀지 않는다. 카탈로그가 커지면
// 동적 import 로 로케일별 코드스플리팅을 검토할 것.
export const i18n = setupI18n({
  locale: getLocalePreference(),
  messages: { ko: koMessages, en: enMessages },
});

/** 언어를 즉시 전환하고 <html lang> 을 갱신한다. 선호값 저장은 호출부 책임. */
export function activateLocale(locale: SupportedLocale) {
  i18n.activate(locale);
  document.documentElement.lang = locale;
}
